require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-tanzania-productive-social-safety-nets-ii-pssn-ii.json") })
        }
      }, "path---en-us-project-tanzania-productive-social-safety-nets-ii-pssn-ii");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-tanzania-productive-social-safety-nets-ii-pssn-ii!./.cache/json/en-us-project-tanzania-productive-social-safety-nets-ii-pssn-ii.json
// module id = 563
// module chunks = 231608221292675